<template>
    <v-app>
        <v-navigation-drawer
                v-model="drawer"
                temporary
                fixed
                dark
                class="black hidden-md-and-up"
        >
            <v-layout column fill-height>
                <v-list>
                    <v-toolbar-items>
                        <user-menu/>
                    </v-toolbar-items>
                    <v-list-tile v-for="item in menuList" :key="item.title" :to="item.link">
                        <v-list-tile-content>
                            <v-list-tile-title class="subheading">{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <social-links class="mt-auto py-2"/>
            </v-layout>
        </v-navigation-drawer>
        <v-toolbar dark color="black" :height="height" :app="!home">
            <v-layout align-center fill-height>
                <v-container class="pa-0 my-0 fill-height" :fluid="fluid">
                    <v-layout :align-center="!(isXs && home)" fill-height :column="home && (isXs || isSm)"
                              :pt-3="home && (isXs || isSm)">

                        <v-toolbar-side-icon v-if="!home" large class="hidden-md-and-up ma-0"
                                             @click.stop="toggleDrawer"></v-toolbar-side-icon>
                        <router-link to="/home" style="display: inherit" class="justify-center">
                            <img :src="require('../assets/FullNameLogo.png')" alt="Score Book"
                                 :height="height > 60 ? 45 : 35">
                        </router-link>
                        <v-spacer></v-spacer>
                        <router-view name="nav"></router-view>

                    </v-layout>
                </v-container>
            </v-layout>
        </v-toolbar>
        <v-content class="white">
            <router-view @showSnackbar="snackbarShow=true"></router-view>
            <v-snackbar
                    v-model="snackbarShow"
                    bottom left
                    :color="snackbarType"
                    :timeout="snackbarTimeout"
            >
                {{ snackbarText }}
                <v-btn
                        icon
                        @click="snackbarShow = false"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-content>

        <v-dialog
                v-if="playDialog.instaplay"
                v-model="playDialog.dialog"
                scrollable :max-width="playDialog.instaplay.InstaplayType === 'bracket' ? 1200 : 375"
                persistent
        >
            <v-card>
                <v-card-title class="headline justify-space-between py-2" primary-title>
                    Play
                    <v-spacer></v-spacer>
                    <v-btn :disabled="isPlayLoading" icon @click="closePlayDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-flex xs12>
                        <v-alert v-model="playStatusAlert" dismissible outline color="error"
                                 style="border-radius: 0.5rem;">
                            {{$store.state.instaplays.playStatus.message}}
                        </v-alert>
                    </v-flex>
                </v-card-title>

                <v-card-text class="pt-0 text-xs-center" style="height: 667px">
                    <v-slide-x-transition leave-absolute>
                        <div v-if="!!playDialog.instaplay">
                            <p v-if="declarePassed">
                                <span v-if="playInfo.winner === 0">Tie</span>
                                <span v-else-if="playInfo.winner">Winner of Instaplay is {{playDialog.instaplay['contestant' + playInfo.winner].name}}</span>
                                <span v-else>Too late in participating - this instaplay is now closed.</span>
                            </p>
                            <p v-else-if="winnerPassed">Too late in participating - this instaplay is now closed.</p>
                            <p v-else-if="startPassed">Contest has started and this instaplay is now closed.</p>
                            <instaplay-preview ref="playInstaplay"
                                               v-else
                                               :instaplay="playDialog.instaplay"
                                               :key="playDialog.instaplay.InstaplayId"
                                               @close="closePlayDialog"
                                               @loginReq="alertDialog.dialog=true"
                                               class="transition-ease-in-out"
                            ></instaplay-preview>
                        </div>
                        <v-btn v-else-if="loading" flat loading/>
                        <p v-else>Instaplay not found.</p>
                    </v-slide-x-transition>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-dialog v-model="alertDialog.dialog" persistent max-width="320">
            <v-card>
                <v-card-title class="headline">Login to register your play and claim SCoins.</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" round depressed @click="closeAlert">ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-app>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    import {mapGetters, mapState} from "vuex";
    import instaplayAPI from "@/services/api/instaplays";
    import {isPassed} from "@/services/time";
    import UserMenu from "@/components/UserMenu";
    import RewardBtn from "@/components/RewardBtn";
    import SocialLinks from "@/components/SocialLinks";

    const {mapFields} = createHelpers({
        getterType: 'notification/getSnackbarField',
        mutationType: 'notification/updateSnackbarField',
    });
    export default {
        name: "BaseLayout",
        components: {SocialLinks, UserMenu, InstaplayPreview: () => import("@/components/InstaplayPreview")},
        data() {
            return {
                loading: false,
                playDialog: {
                    dialog: false,
                    instaplay: undefined
                },
                alertDialog: {
                    dialog: false
                },
                playInfo: {
                    winner: false
                }
            }
        },
        props: {
            home: {
                default: false,
                type: Boolean,
            },
            fluid: {
                default: false,
                type: Boolean
            }
        },
        computed: {
            ...mapFields({
                snackbarShow: 'show',
                snackbarTimeout: 'timeout',
                snackbarText: 'text',
                snackbarType: 'type'
            }),
            ...mapGetters('instaplays', [
                'isPlayLoading',
            ]),
            ...mapState('layout', ['menuList']),
            drawer: {
                get() {
                    return this.$store.state.layout.drawer
                },
                set(val) {
                    this.$store.commit('layout/setDrawer', val)
                }
            },
            playStatusAlert: {
                get() {
                    return this.$store.state.instaplays.playStatus.alert
                },
                set(val) {
                    this.$store.commit('instaplays/setPlayAlert', val)
                }
            },
            declarePassed() {
                let inst = this.playDialog.instaplay
                if (!inst || !inst.declareYear) return false
                return isPassed(inst.declareYear, inst.declareMonth, inst.declareDay, inst.declareHour, inst.declareMinute)
            },
            winnerPassed() {
                let inst = this.playDialog.instaplay
                if (!inst || !inst.winnerYear) return false
                return isPassed(inst.winnerYear, inst.winnerMonth, inst.winnerDay, inst.winnerHour, inst.winnerMinute)
            },
            startPassed() {
                let inst = this.playDialog.instaplay
                if (!inst || !inst.startYear) return false
                return isPassed(inst.startYear, inst.startMonth, inst.startDay, inst.startHour, inst.startMinute)
            },
            height() {
                return this.home
                    ? this.isXs
                        ? 350
                        : this.isSm
                            ? 200 : 120 : 60
            },
            isXs() {
                return this.$vuetify.breakpoint.xsOnly
            },
            isSm() {
                return this.$vuetify.breakpoint.smOnly
            }
        },
        methods: {
            showInstaplay(query) {
                if (query.InstaplayId) {
                    this.loading = true
                    this.playDialog.dialog = true
                    instaplayAPI.getInstaplayUsingID(query.InstaplayId)
                        .then(instaplay => {
                            if (instaplay) {
                                this.playDialog.instaplay = instaplay
                                this.loading = false
                                if (this.declarePassed) {
                                    this.$store.dispatch('instaplays/fetchUserIDs', 'completed').then(
                                        () => {
                                            let play = this.$store.state.instaplays.completedPlays[this.playDialog.instaplay.InstaplayId]
                                            if (play)
                                                this.playInfo = play
                                        }
                                    )
                                }
                            }

                        }).catch(() => this.loading = false)
                }
            },
            closePlayDialog() {
                this.playDialog.dialog = false
                this.playStatusAlert = false
                let query = Object.assign({}, this.$route.query)
                delete query.userid
                delete query.InstaplayId
                this.$router.replace({query})
            },
            closeAlert() {
                this.alertDialog.dialog = false
                this.playDialog.dialog = false
            },
            toggleDrawer() {
                this.$store.commit('layout/setDrawer', !this.$store.state.layout.drawer)
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.showInstaplay(to.query)
            })
        },
        beforeRouteUpdate(to, from, next) {
            this.showInstaplay(to.query)
            next()
        }
    }
</script>

<style>
    nav input:-webkit-autofill,
    nav select:-webkit-autofill,
    nav textarea:-webkit-autofill {
        -webkit-text-fill-color: #ffd300 !important;
        -webkit-box-shadow: 0 0 0 100px #000 inset !important;
        box-shadow: 0 0 0 100px #000 inset !important;
    }
</style>
